import React from 'react';

const NotFound = () => <div>Something went wrong...</div>;

export default NotFound;